const floorPlanLightbox = () => {
	const lightbox = document.getElementById('floor-plan-lightbox');
	const lightboxImg = document.getElementById('lightbox-image');
	const closeBtn = document.querySelector('.lightbox-close');
	const prevBtn = document.querySelector('.lightbox-prev');
	const nextBtn = document.querySelector('.lightbox-next');
	const imageItems = document.querySelectorAll('.floor-plan-image-item[data-lightbox="floor-plan-gallery"]');
	
	if (!lightbox || !lightboxImg || !closeBtn || !prevBtn || !nextBtn || imageItems.length === 0) return;
	
	let currentIndex = 0;

	const images = Array.from(imageItems).map(item => ({
		src: item.querySelector('img').src,
		alt: item.querySelector('img').alt
	}));

	const showImage = (index) => {
		currentIndex = index;
		lightboxImg.src = images[index].src;
		lightboxImg.alt = images[index].alt;
		lightbox.style.display = 'flex';
		document.body.style.overflow = 'hidden';

		// Trigger animation
		setTimeout(() => {
			lightbox.classList.add('active');
		}, 10);
	};

	const closeLightbox = () => {
		lightbox.classList.remove('active');
		setTimeout(() => {
			lightbox.style.display = 'none';
			document.body.style.overflow = '';
		}, 300);
	};

	const showNext = () => {
		currentIndex = (currentIndex + 1) % images.length;
		showImage(currentIndex);
	};

	const showPrev = () => {
		currentIndex = (currentIndex - 1 + images.length) % images.length;
		showImage(currentIndex);
	};

	// Event listeners
	imageItems.forEach((item, index) => {
		item.style.cursor = 'pointer';
		item.addEventListener('click', () => showImage(index));
	});

	closeBtn.addEventListener('click', closeLightbox);
	nextBtn.addEventListener('click', showNext);
	prevBtn.addEventListener('click', showPrev);

	lightbox.addEventListener('click', (e) => {
		if (e.target === lightbox) closeLightbox();
	});

	document.addEventListener('keydown', (e) => {
		if (lightbox.style.display === 'flex') {
			if (e.key === 'Escape') closeLightbox();
			if (e.key === 'ArrowRight') showNext();
			if (e.key === 'ArrowLeft') showPrev();
		}
	});
};

try {
	floorPlanLightbox();
} catch (error) {
	console.error(error);
}
